import React, { useState } from "react";

function ChekoutPage() {
  const [paymentMethod, setPaymentMethod] = useState("tarjeta");

  return (
    <section className="h-100 bg-light py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-body p-5">
                <h2 className="fw-bold mb-4 text-center">Finalizar Compra</h2>

                {/* Resumen de la orden */}
                <div className="mb-4">
                  <h5 className="fw-semibold mb-3">Resumen de tu pedido</h5>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex justify-content-between">
                      <span>Café Inca (x2)</span>
                      <strong>S/. 30.00</strong>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span>Torta Tres Leches</span>
                      <strong>S/. 35.00</strong>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span>Envío</span>
                      <strong>S/. 5.00</strong>
                    </li>
                    <li className="list-group-item d-flex justify-content-between fw-bold">
                      <span>Total</span>
                      <strong>S/. 70.00</strong>
                    </li>
                  </ul>
                </div>

                {/* Métodos de pago */}
                <div className="mb-4">
                  <h5 className="fw-semibold mb-3">Método de Pago</h5>
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="tarjeta"
                      name="paymentMethod"
                      value="tarjeta"
                      checked={paymentMethod === "tarjeta"}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="tarjeta">
                      💳 Tarjeta de Crédito/Débito
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="paypal"
                      name="paymentMethod"
                      value="paypal"
                      checked={paymentMethod === "paypal"}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="paypal">
                      🅿️ PayPal
                    </label>
                  </div>
                </div>

                {/* Formulario dinámico según método */}
                {paymentMethod === "tarjeta" && (
                  <div className="mb-4">
                    <h5 className="fw-semibold mb-3">Detalles de la tarjeta</h5>
                    <div className="mb-3">
                      <label className="form-label">Número de tarjeta</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="1234 5678 9012 3456"
                        required
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Fecha de expiración</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="MM/AA"
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">CVV</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="123"
                          required
                        />
                      </div>
                    </div>
                  </div>
                )}

                {paymentMethod === "paypal" && (
                  <div className="alert alert-info text-center">
                    Serás redirigido a PayPal para completar tu pago.
                  </div>
                )}

                {/* Botón de pago */}
                <button className="btn btn-primary btn-lg w-100 rounded-pill">
                  Confirmar y Pagar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChekoutPage;
